export default class OperationRecord {
  /**
   * コンストラクタ
   * @param {Object} operationRecord redo, undo用の操作履歴
   */
  constructor(operationRecord = null) {
    this._contents = this.paramFromObject(operationRecord, 'contents');

    this._caret_start_key = this.paramFromObject(operationRecord, 'caret_start_key');
    this._caret_end_key = this.paramFromObject(operationRecord, 'caret_end_key');
    this._caret_start = this.paramFromObject(operationRecord, 'caret_start');
    this._caret_end = this.paramFromObject(operationRecord, 'caret_end');
    this._start_separate_index = this.paramFromObject(operationRecord, 'start_separate_index');
    this._end_separate_index = this.paramFromObject(operationRecord, 'end_separate_index');
    this._add_line_keys = this.paramFromObject(operationRecord, 'add_line_keys');
    this._delete_line_keys = this.paramFromObject(operationRecord, 'delete_line_keys');
    this._is_hashira_created_at_head = this.paramFromObject(operationRecord, 'is_hashira_created_at_head');
  }

  paramFromObject(operationRecord, param, initValue = null) {
    return operationRecord == null || operationRecord[param] == null ? initValue : operationRecord[param];
  }

  formatParams() {
    let formData = new FormData();
    const appendFormData = function (name, value) {
      if (value == null) value = '';
      formData.append(`operationRecord[${name}]`, value);
    };
    appendFormData('caret_start_key', this.caret_start_key);
    appendFormData('caret_end_key', this.caret_end_key);
    appendFormData('caret_start', this.caret_start);
    appendFormData('caret_end', this.caret_end);
    appendFormData('start_separate_index', this.start_separate_index);
    appendFormData('end_separate_index', this.end_separate_index);
    appendFormData('add_line_keys', this.add_line_keys);
    appendFormData('delete_line_keys', this.delete_line_keys);
    appendFormData('is_hashira_created_at_head', this.is_hashira_created_at_head);

    if (this.contents) {
      this.contents.forEach((x) => {
        if (x.length > 0) formData.append('operationRecord[contents][]', x);
      });
    }

    return formData;
  }

  /**
   * ObjectからOperationRecordクラスへ変換する
   * @param {Object} obj オブジェクト
   * @returns {OperationRecord} OperationRecord
   */
  static fromObject(obj = null) {
    return new OperationRecord(obj);
  }

  /**
   * キャレット開始位置のElementのname「content-XX」
   * @returns {number}
   */
  get caret_start_key() {
    return this._caret_start_key;
  }

  set caret_start_key(value) {
    this._caret_start_key = value;
  }

  /**
   * キャレット終了位置のElementのname「content-XX」
   * @returns {number}
   */
  get caret_end_key() {
    return this._caret_end_key;
  }

  set caret_end_key(value) {
    this._caret_end_key = value;
  }

  /**
   * キャレット開始位置のオフセット
   * @returns {number}
   */
  get caret_start() {
    return this._caret_start;
  }

  set caret_start(value) {
    this._caret_start = value;
  }

  /**
   * キャレット終了位置のオフセット
   * @returns {number}
   */
  get caret_end() {
    return this._caret_end;
  }

  set caret_end(value) {
    this._caret_end = value;
  }

  /**
   * キャレット開始位置のElementのseparate-index
   * @returns {number}
   */
  get start_separate_index() {
    return this._start_separate_index;
  }

  set start_separate_index(value) {
    this._start_separate_index = value;
  }

  /**
   * キャレット終了位置のElementのseparate-index
   * @returns {number}
   */
  get end_separate_index() {
    return this._end_separate_index;
  }

  set end_separate_index(value) {
    this._end_separate_index = value;
  }

  /**
   * 追加された行のsort_keyの配列
   * @returns {array}
   */
  get add_line_keys() {
    return this._add_line_keys;
  }

  set add_line_keys(value) {
    this._add_line_keys = value;
  }

  /**
   * 削除された行のsort_keyの配列
   * @returns {array}
   */
  get delete_line_keys() {
    return this._delete_line_keys;
  }

  set delete_line_keys(value) {
    this._delete_line_keys = value;
  }

  /**
   * 行の先頭で柱が作成されたかどうか
   * 【備考】先頭行の柱作成ではContentがが追加されるわけではないが、add_line_keysに追加されてしまうため判別させる
   * @returns {array}
   */
  get is_hashira_created_at_head() {
    return this._is_hashira_created_at_head;
  }

  set is_hashira_created_at_head(value) {
    this._is_hashira_created_at_head = value;
  }

  /**
   * contents
   * @returns {array}
   */
  get contents() {
    return this._contents;
  }

  set contents(value) {
    this._contents = value;
  }
}
